<ul class="unstyled">
    <li>{{ address().line1 }}</li>
    <li>{{ address().line2 }}</li>
    <li>{{ address().line3 }}</li>
    <li>{{ address().country.name }}</li>
</ul>
